import { ck, $subscriber } from "fire-wind-water";
import ws from "../services/webinar";
const device = navigator.userAgent;
const isAndroid = device.indexOf("Android") > -1 || device.indexOf("Adr") > -1;
const isMobile = !!navigator.userAgent.match(
  /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
);
const validateEmail = email => {
  let reg = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return email.match(reg);
};
export function buildFlieData(data) {
  return Object.assign(
    {
      fileList: [],
      webinarInfo: {},
      isShow: false,
      user: {},
      showDownloadForm: false,
      userEmail: ck.cookie("user_email"),
      emailErrorMsg: "",
      downloadFile: {}
    },
    data
  );
}
export function buildTableMethod(otherMethods) {
  return Object.assign(
    {
      getFile() {
        let self = this;
        let params = {
          name: "",
          folderId: self.webinarInfo.folderId || 0,
          instanceId: self.webinarInfo.instanceId,
          tenantId: self.webinarInfo.tenantId,
          __module__: 2,
          __objId__: self.webinarInfo.webinarId,
          __typeArr__: ["folder"] // 通过文件夹ID获取，对应的是静态地址规则：file/folder/info
        };
        ws.getResource(params).subscribe(data => {
          self.fileList = data.content.items;
          $subscriber.emit("fileList", data);
        });
      },
      close() {
        this.isShow = false;
      },
      download(f) {
        let self = this;
        let params = {
          instanceId: self.webinarInfo.instanceId,
          fileId: f.fileId,
          applicantId: self.user.applicantId,
          globalUserId: ck.cookie("globalUserId"),
          title: f.name + "." + f.ext,
          sess: self.user.session
        };
        ws.recordFileDownLoad(params).subscribe(data => {
          if (data.result == 0) {
            /**
             * fix issue 81054 https://zt.smarket.com.cn/biz/bug-view-81054.html
             * By judging Android devices, 【window.open】 is used to deal with the problem of no response to download.
             */
            if (isMobile) {
              this.onDownloadByEmail(f);
            } else {
              window.open(f.fileUrl);
            }
          }
        });
      },
      onDownloadByEmail(file) {
        this.showDownloadForm = true;
        this.downloadFile = file;
        this.userEmail = ck.cookie("user_email");
      },
      beforeDownloadFormClose(action, done) {
        const self = this;
        if (action !== "confirm") {
          this.emailErrorMsg = "";
          this.downloadFile = {};
          done();
          return;
        }
        // 验证邮箱输入框
        if (!self.userEmail) {
          self.emailErrorMsg = "请填写邮箱";
          done(false);
          return;
        }
        const tokenInfo = ck.cookie("verifyInfo_" + self.webinarInfo.weChatId);
        if (!validateEmail(self.userEmail)) {
          // 提示邮箱错误
          this.emailErrorMsg = "邮箱格式错误";
          done(false);
          return;
        }
        ck.cookie("user_email", self.userEmail);
        // 发送邮箱下载请求
        ws.downloadWithEmail({
          email: self.userEmail,
          fileList: [self.downloadFile.fileId],
          globalUserId: ck.cookie("globalUserId"),
          sess: self.user.session,
          extra: {
            tenantId: this.webinarInfo.tenantId,
            instanceId: this.webinarInfo.instanceId,
            memberId: 0,
            moduleId: 2,
            openId: tokenInfo ? tokenInfo.original.openid : "",
            weChatId: self.webinarInfo.weChatId,
            objInstanceId: "",
            source: "WAP",
            url: window.location.href
          }
        }).subscribe(data => {
          let msgSend = "文件已发送至邮箱";
          let msgReview = "审核通过后将发送至邮箱";
          let msgError = "提交异常";
          if (data.result != 0) {
            self.$toast.fail(msgError);
          } else if (data.content.isReview == 0) {
            self.$toast.success(msgSend);
          } else if (data.content.isReview == 1) {
            self.$vantDialog.alert({
              title: "提示",
              message: msgReview
            });
          }
          self.downloadFile = {};
          done();
        });
      },
      onInputEmail() {
        this.emailErrorMsg = "";
      }
    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;
  $subscriber.subscribe("webinarInfo", data => {
    self.webinarInfo = data;
    self.getFile();
  });
  $subscriber.subscribe("userInfo", data => {
    self.user = data;
  });
  $subscriber.subscribe("showFile", () => {
    self.isShow = true;
  });
}
